export const REPORT_TIME_ZONE = 'America/New_York';

export const getReportDate = (value) => {
  if (!value) return null;
  const normalized = typeof value === 'string' && /^\d{4}-\d{2}-\d{2}T/.test(value) && !/(Z|[+-]\d{2}:\d{2})$/i.test(value)
    ? `${value}Z`
    : value;
  const date = new Date(normalized);
  if (Number.isNaN(date.getTime())) return null;
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: REPORT_TIME_ZONE, year: 'numeric', month: '2-digit', day: '2-digit',
  }).formatToParts(date);
  const part = (type) => parts.find((item) => item.type === type).value;
  return `${part('year')}-${part('month')}-${part('day')}`;
};

export const getPresetRange = (period, now = new Date()) => {
  const end = getReportDate(now);
  return { start: period === 'year' ? `${end.slice(0, 4)}-01-01` : `${end.slice(0, 7)}-01`, end };
};

const isCalendarDate = (value) => {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return false;
  const parsed = new Date(`${value}T00:00:00Z`);
  return !Number.isNaN(parsed.getTime()) && parsed.toISOString().slice(0, 10) === value;
};

export const validateDateRange = (start, end) => {
  if (!isCalendarDate(start) || !isCalendarDate(end)) return 'Enter a valid start and end date.';
  if (start > end) return 'The end date must be on or after the start date.';
  return '';
};

export const formatReportDate = (value) => new Intl.DateTimeFormat('en-US', {
  month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC',
}).format(new Date(`${value}T00:00:00Z`));

export const formatReportMonth = (value) => new Intl.DateTimeFormat('en-US', {
  month: 'short', year: 'numeric', timeZone: 'UTC',
}).format(new Date(`${value}-01T00:00:00Z`));